var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "checkout-section" },
    [
      _c("div", { staticClass: "checkout-section__header" }, [
        _c("h2", { staticClass: "checkout-section__title" }, [
          _vm._v(_vm._s(_vm.data.flights.title)),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "checkout-section__description",
          domProps: { innerHTML: _vm._s(_vm.data.flights.descriptionHtml) },
        }),
      ]),
      _vm._v(" "),
      _c("YourHoliday", { attrs: { departureDetails: _vm.departureDetails } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout-section__footer" },
        [
          _c("NavButton", { attrs: { back: true, text: "Back" } }),
          _vm._v(" "),
          _c("NavButton", { on: { beforeNextStep: _vm.handleContinueClick } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }